import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Store } from '@ngrx/store';
import { Actions, ofType } from '@ngrx/effects';
import { map, take } from 'rxjs/operators';
import {
  GET_INTEGRATION_IMPORT_ERRORS_FAILURE,
  GET_INTEGRATION_IMPORT_ERRORS_SUCCESS,
  GetIntegrationImportErrorsAction
} from './integration-imports.actions';
import { DefaultIntegrationImportErrorsParams } from './integration-imports.interface';
import { IState } from '../../shared/models/state';

@Injectable()
export class IntegrationImportErrorsResolve implements Resolve<any> {
  constructor(private store: Store<IState>, private action$: Actions) {}

  resolve(route: ActivatedRouteSnapshot) {
    const importId = route.paramMap.get('importId');
    this.store.dispatch(new GetIntegrationImportErrorsAction(new DefaultIntegrationImportErrorsParams(importId)));
    return this.action$.pipe(
      ofType(GET_INTEGRATION_IMPORT_ERRORS_SUCCESS, GET_INTEGRATION_IMPORT_ERRORS_FAILURE),
      map((action: any) => {
        return action.payload;
      }),
      take(1)
    );
  }
}
